import React from "react";

import {
  DependencyItem,
  DependencyList,
} from "src/base-components/DependencyList";
import { FlowDbShallow, FlowVersionStatus } from "src/clients/flow-api";
import { Modal } from "src/design-system/Modal";
import { VersionStatusPill } from "src/flow/Pills";
import { useFlowContext } from "src/router/routerContextHooks";
import { getBaseUrl, getUrlToAuthoringPage } from "src/router/urls";

export type Props = {
  open: boolean;
  onClose: () => void;
  afterLeave: () => void;
  title: string;
  subtitle: string;
  relatedFlows: FlowDbShallow[] | undefined;
  filterArchivedVersions?: boolean;
};

const flowsToDependencyItems = (
  flows: FlowDbShallow[],
  orgId: string,
  wsId: string,
  filterArchivedVersions = false,
): DependencyItem[] =>
  flows.flatMap(({ id: flowId, name: flowName, versions }) =>
    (versions ?? [])
      .filter(
        ({ status }) =>
          !filterArchivedVersions || status !== FlowVersionStatus.ARCHIVED,
      )
      .map(({ id, name, status }) => ({
        id,
        name: `${flowName} - ${name}`,
        group: "Flows",
        href: getBaseUrl() + getUrlToAuthoringPage(orgId, wsId, flowId, id),
        statusPill: <VersionStatusPill status={status} />,
      })),
  );

export const RelatedFlowsModal: React.FC<Props> = ({
  open,
  onClose,
  afterLeave,
  title,
  subtitle,
  relatedFlows,
  filterArchivedVersions = false,
}) => {
  const { workspace, orgId } = useFlowContext();

  const flowItems = flowsToDependencyItems(
    relatedFlows ?? [],
    orgId,
    workspace.id,
    filterArchivedVersions,
  );

  return (
    <Modal afterLeave={afterLeave} open={open} onClose={onClose}>
      <Modal.Header description={subtitle}>{title}</Modal.Header>
      <Modal.Content>
        <DependencyList dataLoc="related-dependencies" items={flowItems} />
      </Modal.Content>
      <Modal.Footer primaryButton={false} secondaryButton="Cancel" />
    </Modal>
  );
};
